import { createSelector } from "reselect";

const weatherMoratorium = () => (state) => state.weatherMoratorium;

const selectWeatherMoratoriumContainer = () =>
  createSelector(weatherMoratorium(), (weatherMoratoriumData) => {
    return weatherMoratoriumData;
  });

export default selectWeatherMoratoriumContainer;
